import constate from 'constate';

interface AdvertisementProps {
  image: string;
}

const useAdvertisement = (props: AdvertisementProps) => {
  const { image } = props;

  return { image };
};

export const [AdvertisementProvider, useAdvertisementContext] =
  constate(useAdvertisement);
